<template>
    <TemplateDetails :get-function="getRecomVoucher" :data="voucher" :loading="voucherLoading">

        <PageBack/>

        <PageHeader :title="$t('recomVouchers.detail.title')">
            <template v-slot:actions v-if="voucher && (editAllowed || voucher.state !== 'refund')">
                <Button v-if="editAllowed" @click.native="$refs.popinEdit.open" color="black" size="m" icon="edit">{{ $t('voucher.edit.button') }}</Button>
                <Button v-if="voucher.state === 'available'" @click.native="$refs.popinRefund.open" color="red" size="m" icon="trash">{{ $t('global.delete') }}</Button>
            </template>
        </PageHeader>

        <SectionTableInfos :object="voucher" :fields="fields"/>

        <Popin v-if="voucher" :title="$t('voucher.cancel.title')" :subtitle="$t('voucher.cancel.subtitle')" :text="isUsed ? $t('voucher.refund.alert') : null" :center="true" ref="popinRefund">
            <template v-slot:content>
                <Button :loading="refundLoading" color="red" size="m" @click.native.prevent="refund">{{ $t('global.deleteConfirm') }}</Button>
            </template>
            <template v-slot:bottom>
                <LinkUnderline @click.native.prevent="$refs.popinRefund.close">{{ $t('global.cancel') }}</LinkUnderline>
            </template>
        </Popin>

        <Popin :title="$t('voucher.edit.title')" :subtitle="$t('voucher.edit.subtitle')" :center="true" ref="popinEdit" class="popin-edit-voucher">
            <template v-slot:content>
                <Form :fields="[{key: 'code', required: true, type: 'text', label: $t('voucher.edit.input')}]"
                      :action="editRecomVoucher"
                      :model="voucher"
                      @success="$refs.popinEdit.close(); $refs.popinEditNotification.open()"/>
            </template>
            <template v-slot:bottom>
                <LinkUnderline @click.native.prevent="$refs.popinRefund.close">{{ $t('global.cancel') }}</LinkUnderline>
            </template>
        </Popin>

        <PopinNotification ref="popinEditNotification" :text="$t('voucher.edit.success')"/>
        <PopinNotification ref="popinRefundSuccessNotification" :text="refundMessage"/>
        <PopinNotification ref="popinRefundErrorNotification" :text="$t('voucher.cancel.error')"/>
    </TemplateDetails>
</template>

<script>
import TemplateDetails from '@/components/templates/TemplateDetails';
import PageBack from '@/components/ui/page/PageBack';
import PageHeader from '@/components/ui/page/PageHeader';
import SectionTableInfos from '@/components/sections/SectionTableInfos';
import { mapState, mapActions } from 'vuex';
import Button from '@/components/ui/button/Button';
import Popin from '@/components/ui/popin/Popin';
import LinkUnderline from '@/components/ui/link/LinkUnderline';
import Form from '@/components/ui/form/Form';
import PopinNotification from '@/components/ui/popin/PopinNotification';

export default {
    name: 'RecomVoucherPage',
    components: {PopinNotification, Form, LinkUnderline, Popin, Button, SectionTableInfos, PageHeader, PageBack, TemplateDetails},
    data() {
        return {
            refundLoading: false,
            refundMessage: this.$t('voucher.refund.success'),
            fields: [
                {key: 'id', type: 'copy'},
                {key: 'brand', translationKey: 'client', type: 'client', size: 'l'},
                {key: 'customer', translationKey: 'user', type: 'userEmail', size: 'xl'},
                {key: 'amount', type: 'formatPrice'},
                {key: 'code', type: 'editVoucher', size: 'l'},
                {key: 'createdAt', type: 'date', size: 'm'},
                {key: 'expiredAt', translationKey: 'expiresOn', type: 'date', size: 'm'},
                {key: 'type', type: 'voucherType', size: 'm', translationKey: 'channel_of_use'},
                { key: 'state', param: 'recom_voucherState', type: 'giftCardStatus', size: 'm' },
                {key: 'burned', translationKey: 'isBurned', type: 'strictBoolean', size: 'm'},
                {key: 'burnedAt', type: 'date', size: 'm'},
                {key: 'customer.countryCode', translationKey: 'country', size: 's'},
            ]
        }
    },
    computed: {
        ...mapState(['voucher', 'voucherLoading']),
        isUsed() {
            return this.voucher?.burned
        },
        editAllowed() {
            if (!this.voucher) return false;
            return ([12, 14, 19].includes(this.voucher.brand?.id)) && this.voucher.state === 'manual' && !this.voucher.burned
        }
    },
    methods: {
        ...mapActions(['getRecomVoucher', 'refundRecomVoucher', 'editRecomVoucher', 'unsetVoucher', 'updateRecomVoucher']),
        refund() {
            this.refundLoading = true;
            this.refundRecomVoucher()
                .then(response => {
                    this.refundMessage = response?.data?.message || this.$t('voucher.cancel.success');
                    this.$refs.popinRefund.close();
                    this.$refs.popinRefundSuccessNotification.open();
                    this.updateRecomVoucher();
                })
                .catch((error) =>  {
                    console.error(error)
                    this.$refs.popinRefundErrorNotification.open()
                })
                .finally(() => this.refundLoading = false)
        }
    },
    destroyed() {
        this.unsetVoucher()
    }
}
</script>

<style lang="scss">
.popin-edit-voucher {
    .field__input {
        border: var(--border-2);
    }

    .field__label {
        background-color: #fff;
        padding: 0 4px;
    }
}
</style>